import * as api from './adapter';

export default {
  index: () => ({
    data: {
      data: [
        { id: '020b39f4', attributes: { name: 'STRONGTEC', short_name: 'STRONGTEC' } },
        { id: '02db4ced', attributes: { name: 'DEARSAN SHIPYARD', short_name: 'DEARSAN SHIPYARD' } },
        { id: '0ae61044', attributes: { name: 'HYUNDAI SHIPYARD', short_name: 'HYUNDAI SHIPYARD' } },
        { id: '16c5924a', attributes: { name: 'ASSTILLEROS', short_name: 'ASSTILLEROS' } },
        { id: '25e6146e', attributes: { name: 'XINGANG SHIPYARD', short_name: 'XINGANG SHIPYARD' } },
        { id: '263afa97', attributes: { name: 'BOSS SHIPPING CO.LTD', short_name: 'BOSS SHIPPING CO.LTD' } },
        { id: '3341aee0', attributes: { name: 'GDANSKA STOCZNIA "REMONTOWA"', short_name: 'GDANSK SHIPYARD' } },
        { id: '3e60c8ee', attributes: { name: 'SHANGHAIGUAN SHIPYARD', short_name: 'SHANGHAIGUAN SHIPYAR' } },
        { id: '4633c8', attributes: { name: 'CHENGXI SHIPYARD (XINRONG) CO., LTD.', short_name: 'CHENGXI SHIPYARD' } },
        { id: '483b30e1', attributes: { name: 'ARNO SHIPYARD', short_name: 'ARNO SHIPYARD' } },
        { id: '6f68a009', attributes: { name: 'CHUGOKU PAINTS B.V.', short_name: 'CHUGOKU PAINTS B.V.' } },
        { id: '7fd42918', attributes: { name: 'NOT COMPANY', short_name: 'NOT COMPANY' } },
        { id: '86f905ba', attributes: { name: 'FIRM CASTLE HOLDINGS LLC.', short_name: 'CASTLE HOLDINGS' } },
        { id: '95d3e9d2', attributes: { name: 'POLAR DENIZCILIK VE DENIZ MALZEMELERI A.S.', short_name: 'POLAR' } },
        { id: 'b6181eb9', attributes: { name: 'BARWIL UNIVERSAL AGENCIES ISTAMBUL', short_name: 'BARWIL ISTANBUL' } },
      ],
      meta: { count: 19, page_count: 2 },
      links: {
        first: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=1&page%5Bsize%5D=15',
        next: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=2&page%5Bsize%5D=15',
        last: 'http://qa2.planvisor.softo.net/vacancies?page%5Bnumber%5D=2&page%5Bsize%5D=15',
      },
    },
  }),
  /**
   * show
   * @param id
   * @return {Promise}
   */
  show: (id) => api.read(`/vendors/${id}`),
  /**
   * createCrewUser
   * @param attributes
   * @returns {Promise}
   */
  create: (attributes) => api.create({ type: 'vendors', attributes }),
  /**
   * updateCrewUser
   * @param id
   * @param attributes
   * @returns {Promise}
   */
  update: (id, attributes) => api.update({ id, type: 'vendors', attributes }),
  /**
   * deleteCrewUser
   * @returns {Promise<*>}
   */
  delete: (id) => api.destroy({ id, type: 'vendors' }),
};
